import { createClient } from "@supabase/supabase-js";
import { createBoundedAuthFetch } from "@/lib/supabase/bounded-auth-fetch";
import {
  createServerHeldStorage,
  routeTokenGrantsToOrigin,
} from "@/lib/supabase/server-held-session";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Supabase environment variables not set. Auth will not work.\n" +
      "Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY in .env.local"
  );
}

const url = supabaseUrl || "https://placeholder.supabase.co";
const storageKey = `sb-${new URL(url).hostname.split(".")[0]}-auth-token`;

// Not @supabase/ssr's createBrowserClient: that one stores the session in
// document.cookie, which needs the cookie readable by page script. Ours is
// HttpOnly (CASA 2.3.2); the session lives server-side and page memory holds
// only the access token. See server-held-session.ts.
//
// Never call signInWithOAuth / exchangeCodeForSession from the browser: the
// PKCE verifier would land in page memory and be gone by the time Google
// redirects back. OAuth starts at /auth/google and finishes at /auth/callback,
// both on the server.
export const supabase = createClient(
  url,
  supabaseAnonKey || "placeholder-key",
  {
    auth: {
      storageKey,
      storage: createServerHeldStorage({
        fetch: (input, init) => fetch(input, init),
        sessionKey: storageKey,
      }),
      persistSession: true,
      autoRefreshToken: typeof window !== "undefined",
      detectSessionInUrl: false,
      flowType: "pkce",
    },
    global: {
      // supabase-js hands this straight to the auth client, whose token-refresh
      // fetch otherwise carries no AbortSignal — a half-open socket hangs it
      // forever and strands the app on the gate curtain. See bounded-auth-fetch.
      fetch: createBoundedAuthFetch(
        routeTokenGrantsToOrigin((input, init) => fetch(input, init), url)
      ),
    },
  }
);
